import HelpdeskGraphQL from "./HelpdeskGraphQL";
import axios from "./Axios";
import {HELPDESK_SERVICE_URL} from "../config";

class Scenarios extends HelpdeskGraphQL {
    static async getAllScenarios(brandId) {
        return await axios()({
            url: HELPDESK_SERVICE_URL + '/scenarios/all/'+brandId+'?onlyLive=yes',
            method: 'GET',
        });
	}
	
    static async getPersonIdFromCookieId(cookieId,tenantId){
        const queryName = 'getPersonIdFromCookieId';
        const query = `
    query ${queryName}($cookieId: ID!,$tenantId:String!) {
    ${queryName}(cookieId: $cookieId,tenantId:$tenantId) 
}`;
        const variables = {
            cookieId,
            tenantId
        };
        return await this.run({ query, variables, queryName });
    }
}
export default Scenarios
